module.exports = __webpack_public_path__ + "img/Colibri_fond_transparent.36c2f3ba.png";